module.exports = __webpack_public_path__ + "media/sziv.ea1b1ff2.webm";